import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { configurationKey } from '@/injections';

const useHidePricing = () => {
  const store = useStore();
  const configuration = inject(configurationKey);

  const isGuest = computed(() => store.getters['user/isGuest']);
  const shouldHideItemPrices = computed(() => configuration?.hidePriceUntilLogin && isGuest.value);

  return {
    shouldHideItemPrices,
  };
};
export default useHidePricing;
